import React from "react";
import { Card, Button, Modal, message, Popconfirm } from "antd";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Row, Col, Form, FormGroup, Label, Input, } from 'reactstrap';
import Media from 'react-media';

import { services } from '../../../services/services';
import { use_logiciel } from '../../../env'




class NatureDepense extends React.Component {
  state = {
    isModalVisible: false,
    isAddModalVisible: false,
    isUpdateModalVisible: false,
    loading: false,
    natures: [],

    codeNatDep: '',
    libelleNatDep: '',


  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
  componentDidMount() {
    services.getNatureDepense()
      .then(natures => {
        console.log('natures', natures)
        this.setState({ natures })
      })


  }
  handleAddOpen = () => {
    this.setState({ isAddModalVisible: !this.state.isAddModalVisible, });
  };

  handleCancelAdd = () => {
    this.setState({
      isAddModalVisible: !this.state.isAddModalVisible,
      codeNatDep: '',
      libelleNatDep: '',

    })
  }

  handleAddNature = () => {
    const {
      //codAgence,
      libelleNatDep,

    } = this.state


    if (libelleNatDep === '') {
      message.warning('Veuillez préciser le libellle de la Nature de dépense', 5)
      return;
    }
    /*if (codAgence === '') {
      message.warning('Veuillez sélectionner une Agence', 5)
      return;
    }*/

    this.setState({ loading: true })

    let req = {

      libelleNatDep: libelleNatDep.toUpperCase(),
    }
    services.addNatureDepense(req)
      .then(result => {
        // console.log(result)
        this.setState({
          libelleNatDep: '',

          loading: false,
          isAddModalVisible: !this.state.isAddModalVisible,

        })
        message.success('Nature ajouter avec succès', 10)

        services.getNatureDepense()
          .then(natures => {
            this.setState({ natures })
          })

      })

      .catch((err) => {
        this.setState({ loading: false })
        message.error(err, 10)

      });
  }

  handleUpdateNature = () => {
    const {

      codeNatDep,
      libelleNatDep,

    } = this.state


    if (libelleNatDep === '') {
      message.warning('Veuillez préciser le libellle de la Nature de recette', 5)
      return;
    }
    if (codeNatDep === '') {
      message.warning('Veuillez sélectionner le Code de la nature de recette', 5)
      return;
    }

    let req = {
      codeNatDep,
      libelleNatDep: libelleNatDep.toUpperCase(),
    }
    services.updateNatureDepense(req)
      .then(result => {
        // console.log(result)
        this.setState({
          codeNatDep: '',
          libelleNatDep: '',

          isUpdateModalVisible: !this.state.isUpdateModalVisible,

        })
        message.success('Nature modifier avec succès', 10)

        services.getNatureDepense()
          .then(natures => {
            this.setState({ natures })
          })

      })

      .catch(() => {
        message.error('Une erreur est survenue lors de la modification, Veuillez réessayer plus tard', 10)
      });
  }

  handleDelete = (row) => {
    this.setState({
      codeNatDep: row.codeNatDep,
      libelleNatDep: row.libelleNatDep,
    })

  }

  handleDeleteNature = () => {

    const { codeNatDep } = this.state

    services.deleteNatureDepense(codeNatDep)
      .then(del => {
        //console.log('delete user', del)
        message.success('Nature supprimer avec succès', 10)
        services.getNatureDepense()
          .then(natures => {
            this.setState({ natures })
          })

      })
      .catch((err) => {
        message.error(err, 10)
      });

  }

  handleUpdateOpen = (row) => {
    this.setState({
      isUpdateModalVisible: !this.state.isUpdateModalVisible,
      //idAgence: row.id,
      codeNatDep: row.codeNatDep,
      libelleNatDep: row.libelleNatDep,

    })

  }
  handleCancelUpdate = () => {
    this.setState({
      isUpdateModalVisible: !this.state.isUpdateModalVisible,
      codeNatDep: '',
      libelleNatDep: '',

    })
  }


  handleView = (row) => {
    this.setState({
      isModalVisible: !this.state.isModalVisible,
      codeNatDep: row.codeNatDep,
      libelleNatDep: row.libelleNatDep,

    });
  };

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
      codeNatDep: '',
      libelleNatDep: '',
    });
  }


  render() {
    const {
      isModalVisible,
      loading,
      //codeNatDep,
      libelleNatDep,
      natures,


      isAddModalVisible,
      isUpdateModalVisible
    } = this.state


    //const Option = Select.Option;

    const { SearchBar } = Search;

    const columnsNatures = [
      /*{
      dataField: 'id',
      text: ' ID'
    },*/ {
        dataField: 'codeNatDep',
        text: ' Code',
        headerAttrs: { width: 100 },

      }, {
        dataField: 'libelleNatDep',
        text: ' Libellé'
      },


      {
        dataField: '',
        text: 'Action',
        headerAlign: 'center',
        sort: true,
        headerAttrs: { width: 50 },
        align: 'center',
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            < div
              style={{ textAlign: "center" }} className="d-flex">
              <Button

                //hidden= { use_logiciel === 'NO' ? false : true}
                type="primary"
                //fullWidth
                variant="contained"
                color="primary"
                size="small"
                //className="btn btn-success btn-sm"
                onClick={() => this.handleView(row)}
              >
                <i className="icon icon-custom-view" />
              </Button>
              <Button
                hidden={use_logiciel === 'NO' ? false : true}
                type="primary"
                //fullWidth
                variant="contained"
                color="danger"
                size="small"
                //className="btn btn-success btn-sm"
                onClick={() => this.handleUpdateOpen(row)}
              >
                <i className="icon icon-edit" />
              </Button>
              <Popconfirm placement="left" title="Êtes vous sûr de vouloir supprimer cette Nature de dépense?" onConfirm={this.handleDeleteNature} onCancel={this.cancelDelete} okText="Oui"
                cancelText="Non">
                <Button
                  hidden={use_logiciel === 'NO' ? false : true}
                  type="danger"
                  //fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  //className="btn btn-success btn-sm"
                  onClick={() => this.handleDelete(row)}
                >
                  <i className="icon icon-alert-new" />
                </Button>

              </Popconfirm>

            </div>
          );
        },

      }

    ];


    const columnsNaturesPhone = [

      {
        dataField: 'libelleNatDep',
        text: ' Libellé'
      },


      {
        dataField: '',
        text: 'Action',
        headerAlign: 'center',
        sort: true,
        headerAttrs: { width: 50 },
        align: 'center',
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            < div
              style={{ textAlign: "center" }} className="d-flex">
              <Button
                type="primary"
                //fullWidth
                variant="contained"
                color="primary"
                size="small"
                //className="btn btn-success btn-sm"
                onClick={() => this.handleView(row)}
              >
                <i className="icon icon-custom-view" />
              </Button>
              <Button
                hidden={use_logiciel === 'NO' ? false : true}
                type="primary"
                //fullWidth
                variant="contained"
                color="danger"
                size="small"
                //className="btn btn-success btn-sm"
                onClick={() => this.handleUpdateOpen(row)}
              >
                <i className="icon icon-edit" />
              </Button>
              <Popconfirm placement="left" title="Êtes vous sûr de vouloir supprimer cette Nature de dépense?" onConfirm={this.handleDeleteNature} onCancel={this.cancelDelete} okText="Oui"
                cancelText="Non">
                <Button
                  hidden={use_logiciel === 'NO' ? false : true}
                  type="danger"
                  //fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  //className="btn btn-success btn-sm"
                  onClick={() => this.handleDelete(row)}
                >
                  <i className="icon icon-alert-new" />
                </Button>

              </Popconfirm>

            </div>
          );
        },

      }

    ];

    const defaultSorted = [{
      dataField: 'libelleNatDep',
      order: 'asc'
    }];



    return (
      <div>
        <Card title="Liste des Natures de Dépense">

          <Media query="(min-width: 600px)" render={() =>
          (
            <ToolkitProvider
              keyField="id"
              data={natures}
              columns={columnsNatures}
              //cellEdit={cellEditFactory({ mode: 'dbclick' })}
              search
              //insertRow={true}
              exportCSV

            >
              {
                props => (
                  <div>
                    <Row >
                      <Col md={6} style={{ display: 'flex', alignItems: 'baseline' }}>
                        {/*<i className="fa fa-search" style={{ margin: 10 }}></i> */}

                        <SearchBar {...props.searchProps}
                          //delay={ 1000 }
                          style={{ maxWidth: 750, width: '180%', margin: 'auto', display: 'flex', borderRadius: 50 }}
                          placeholder="Rechercher"

                        />
                      </Col>
                      {use_logiciel === 'NO' &&  //currentUser && currentUser.slug === 'COMMERCIAL_ROLE' &&
                        <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', }}>

                          <button style={{ marginLeft: 3 }}
                            className="btn bg-primary text-light rounded"
                            onClick={this.handleAddOpen}>
                            NOUVEAU <i className="icon icon-add" />
                          </button>
                        </Col>

                      }
                    </Row>


                    <BootstrapTable
                      {...props.baseProps}
                      //bootstrap4
                      wrapperClasses="table-responsive"
                      //selectRow={ selectRow }
                      //defaultSorted={defaultSorted}
                      pagination={paginationFactory()}
                      defaultSorted={defaultSorted}
                      striped
                      hover
                      condensed
                      headerWrapperClasses="foo"
                      noDataIndication="Vous n'avez aucun enrégistrement, veuillez cliquer sur Nouveau pour en ajouter"
                    //filter={filterFactory()}
                    />

                  </div>

                )
              }
            </ToolkitProvider>
          )}
          />


          <Media query="(max-width: 599px)" render={() =>
          (

            <ToolkitProvider
              keyField="id"
              data={natures}
              columns={columnsNaturesPhone}
              //cellEdit={cellEditFactory({ mode: 'dbclick' })}
              search
              //insertRow={true}
              exportCSV

            >
              {
                props => (
                  <div>
                    <Row >
                      <Col md={6} style={{ display: 'flex', alignItems: 'baseline' }}>
                        <i className="fa fa-search" style={{ margin: 10 }}></i>

                        <SearchBar {...props.searchProps}
                          //delay={ 1000 }
                          style={{ maxWidth: 450, width: '125%', margin: 'auto', display: 'flex', borderRadius: 50 }}
                          placeholder="Rechercher"

                        />
                      </Col>
                      {//currentUser && currentUser.slug === 'COMMERCIAL_ROLE' &&
                        <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'baseline', }}>

                          <button style={{ marginLeft: 3 }}
                            className="btn bg-primary text-light rounded"
                            onClick={this.handleAddOpen}>
                            NOUVEAU <i className="icon icon-add" />
                          </button>
                        </Col>
                      }

                    </Row>

                    <BootstrapTable
                      {...props.baseProps}
                      //bootstrap4
                      wrapperClasses="table-responsive"
                      //selectRow={ selectRow }
                      //defaultSorted={defaultSorted}
                      pagination={paginationFactory()}
                      defaultSorted={defaultSorted}
                      striped
                      hover
                      condensed
                      headerWrapperClasses="foo"
                      noDataIndication="Vous n'avez aucun enrégistrement, veuillez cliquer sur Nouveau pour en ajouter"
                    //filter={filterFactory()}
                    />

                  </div>

                )
              }
            </ToolkitProvider>
          )}
          />
        </Card>


        <Modal
          width={500}
          visible={isAddModalVisible}
          title="Ajouter une Nature de dépense"
          //onOk={this.handleAddOpen}
          onCancel={this.handleCancelAdd}
          footer={[
            <Button  type="primary" loading={loading} onClick={this.handleAddNature}>
              Envoyer
            </Button>,
            <Button  type="danger" onClick={this.handleCancelAdd}>
              Annuler
            </Button>,

          ]}
        >
          <Form>
            <Row form>
             
              
              <Col md={12}>
                <FormGroup>
                  <Label for="libelleNatDep">Libellé</Label>
                  <Input type="text" name="libelleNatDep" value={libelleNatDep} onChange={this.handleChange} id="libelleNatDep" placeholder="" />
                </FormGroup>
              </Col>
            </Row>

          </Form>
        </Modal>

        <Modal
          width={500}
          visible={isUpdateModalVisible}
          title="Modifier la nature de dépense"
          //onOk={this.handleAddOpen}
          onCancel={this.handleCancelUpdate}
          footer={[
            <Button  type="primary" loading={loading} onClick={this.handleUpdateNature}>
              Modifier
            </Button>,
            <Button  type="danger" onClick={this.handleCancelUpdate}>
              Annuler
            </Button>,


          ]}
        >
          <Form>
           {/*} <Row form>
            
              <Col md={6}>
                <FormGroup>
                  <Label for="codeNatDep">Codification</Label>
                  <Input disabled type="text" name="codeNatDep" value={codeNatDep} id="codeNatDep" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>
          */}

            <FormGroup>
              <Label for="libelleNatDep">Libellé</Label>
              <Input type="text" name="libelleNatDep" value={libelleNatDep} onChange={this.handleChange} id="libelleNatDep" placeholder="" />
            </FormGroup>

          </Form>
        </Modal>

        <Modal
          width={500}
          visible={isModalVisible}
          title="Détails Nature dépense"
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
          footer={[
            <Button  type="danger" onClick={this.handleCancel}>
              Retour
            </Button>,
          
          ]}
        >
          <Form>
             {/* <Row form>
          
              <Col md={12}>
                <FormGroup>
                  <Label for="codeNatDep">Code</Label>
                  <Input disabled type="text" name="codeNatDep" value={codeNatDep} id="codeNatDep" onChange={this.handleChange} placeholder="" />
                </FormGroup>
              </Col>
            </Row>*/}

            <FormGroup>
              <Label for="libelleNatDep">Libellé</Label>
              <Input disabled type="text" name="libelleNatDep" value={libelleNatDep} onChange={this.handleChange} id="libelleNatDep" placeholder="" />
            </FormGroup>

          </Form>
        </Modal>

      </div>
    )
  }
}


export default NatureDepense;
